import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { useLingui } from "@lingui/react/macro";
import { useSearch } from "@tanstack/react-router";
import { useState } from "react";
import { MaterialsTabContent } from "@/components/materials";
import { PageTitle } from "@/components/layout/PageTitle";

const materialsSearchSchema = z.object({
  page: z.number().catch(1),
  pageSize: z.number().catch(50),
  search: z.string().optional(),
  sortBy: z.string().optional(),
  sortOrder: z.enum(["asc", "desc"]).optional(),
  ingredientStatus: z.enum(["all", "active", "inactive"]).catch("all"),
});

export const Route = createFileRoute("/(protected)/_layout/materials/")({
  validateSearch: (search) => materialsSearchSchema.parse(search),
  component: MaterialsPage,
});

function MaterialsPage() {
  const { t } = useLingui();
  const searchParams = useSearch({ from: "/(protected)/_layout/materials/" });
  const navigate = useNavigate();
  const [createOpen, setCreateOpen] = useState(false);

  const onNavigate = (
    updater: (prev: typeof searchParams) => typeof searchParams,
  ) => void navigate({ from: "/materials/", search: updater, replace: true });

  return (
    <div className="flex flex-col gap-5 py-5 px-3">
      <PageTitle size="lg" title={t`Materials`} className="px-3" />
      <MaterialsTabContent
        searchParams={searchParams}
        onNavigate={onNavigate}
        createOpen={createOpen}
        onCreateOpenChange={setCreateOpen}
      />
    </div>
  );
}
